import { Grid, Checkbox, Typography, createTheme, FormControlLabel, Avatar } from '@material-ui/core';
import React, { useState, useEffect, useRef } from 'react';
import { tick } from '../../blocks/appointmentmanagement/src/assets';
const AddParticipants: { [key: string]: string } = {
    "en": "Add Participants",
    "fr": "Ajouter des participants",
    "de": "Teilnehmer hinzufügen",
    "es": "Agregar participantes"
  }

  const SearchUser: { [key: string]: string } = {
      "en": "Search User",
      "fr": "Rechercher un utilisateur",
      "de": "Benutzer suchen",
      "es": "Buscar usuario"
    }
const theme = createTheme({
    palette: {
        primary: {
            main: "#0000ff",
            contrastText: "#fff",
        },
    },
});
type PatientOption = {
    id: string;
    full_name: string;
    id_number?: string;
    patient_id?: string;
    profile_image?: string;
  };

  const patientDisplayId = (option: any) => option?.id_number || option?.patient_id || "";

  function CustomDropDownWithSearch({ options, onSelect, SelectedPatients, edit, disableflag, language }: any) {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedItems, setSelectedItems] = useState<PatientOption[]>([]);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const lng : { [key: string]: string } = {
        en: "Add all",
        fr: "ajouter tout",
        es: "agregar todo",
        de: "alles hinzufügen",
      }
  
    useEffect(() => {
      setSelectedItems(SelectedPatients || []);
    }, [SelectedPatients]);
  
    const getInitials = (name: any) => {
      if (name) {
        const words = name.split(' ');
        const initials = words.map((word: string) => word.charAt(0).toUpperCase());
        return initials.join('');
      } else {
        return '';
      }
    };
  
    const handleOptionClick = (option: any) => {
      setSelectedOption(option);
      onSelect(option);
    };
  
    const handleCheckboxChange = (option: any) => {
      const foundObject = selectedItems.find((obj) => obj.id === option.id);
      let updatedList;
      if (foundObject) {
        updatedList = selectedItems.filter((item) => item.id !== option.id);
      } else {
        updatedList = [...selectedItems, option];
      }
      setSelectedItems(updatedList);
      edit(updatedList);
    };
  
    const handleCheckedValue = (option: any) => {
      return selectedItems.some((patient: any) => patient.id === option.id);
    };
  
    const filteredOptions = options?.filter((option: any) => {
        const query = searchQuery.toLowerCase();
        return (
          String(option.full_name || "").toLowerCase().includes(query) ||
          String(patientDisplayId(option)).toLowerCase().includes(query)
        );
    });
  
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
  
    const handleSelectAll = () => {
      const unselectedOptions = filteredOptions.filter(
        (option: any) => !selectedItems.some((patient: any) => patient.id === option.id)
      );
      const updatedList = [...selectedItems, ...unselectedOptions];
      setSelectedItems(updatedList);
      edit(updatedList);
    };
  
    const isAllSelected = filteredOptions.length > 0 && filteredOptions.every((option: any) =>
      selectedItems.some((patient: any) => patient.id === option.id)
    );
  
    useEffect(() => {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);
  
    return (
      <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
        <div
          style={{
            display: 'flex',
            padding: '10px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            alignItems: 'center',
            borderRadius: '5px',
            justifyContent: 'space-between',
          }}
          onClick={() => disableflag ? console.log(disableflag) : setIsOpen(!isOpen)}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src={require('./profile.svg')} style={{ width: '20px', height: '20px', flexShrink: 0, marginRight: '5px' }} />
            <span style={selectedOption ? { color: '#454545', fontFamily: 'Inter', fontSize: '14px' } : { color: '#939393', fontFamily: 'Inter', fontSize: '14px' }}>
              {selectedOption || AddParticipants[language]}
            </span>
          </div>
          <img src={require('./arrow-down.png')} />
        </div>
  
        {isOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            width: '100%',
            backgroundColor: '#fff',
            maxHeight: '200px',
            overflowY: 'auto',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '5px',
            zIndex: 100,
            marginBottom: '20px'
          }}>
            <input
              type="text"
              placeholder={SearchUser[language]}
              style={{
                width: '95%',
                padding: '10px',
                margin: '10px',
                borderRadius: '4px',
                border: '1px solid #E6E6E6',
                background: '#FFF'
              }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
  
            <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '0 10px 10px 10px' }}>
              <button
                disabled={isAllSelected}
                style={{
                  padding: '6px 12px',
                  backgroundColor: isAllSelected ? '#ccc' : '#6A1B9A',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: isAllSelected ? 'not-allowed' : 'pointer',
                  fontSize: '12px'
                }}
                onClick={handleSelectAll}
              >
                {lng[language]}
              </button>
            </div>
  
            {filteredOptions.length === 0 && (
                   <div style={{textAlign:"center",marginBottom:'20px'}}>No participants Found</div>
            )}
            
            {filteredOptions && filteredOptions.length > 0 && filteredOptions.map((option: any, index: number) => (
              <Grid container spacing={3} alignItems="center" key={index}>
                <Grid item xs={1}>
                  <FormControlLabel
                    label=""
                    control={
                      <Checkbox
                        style={{
                          borderRadius: '6.667px',
                          border: '1.667px solid #E6E6E6',
                          background: '#FFF',
                          marginLeft: '20px'
                        }}
                        checked={handleCheckedValue(option)}
                        onChange={() => handleCheckboxChange(option)}
                        icon={<span style={{ width: '4px', height: '4px', flexShrink: 0 }} />}
                        checkedIcon={<img src={tick} />}
                      />
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <Avatar
                    style={{
                      width: theme.spacing(7),
                      height: theme.spacing(7),
                      backgroundColor: '#F6EEFF',
                      color: 'black',
                      marginLeft: '10px'
                    }}
                    src={option.profile_image || ''}
                  >
                    {!option.profile_image && getInitials(option.full_name)}
                  </Avatar>
                </Grid>
                <Grid item xs={9}>
                  <Typography style={{
                    color: '#292929',
                    fontFamily: 'Jost',
                    fontSize: '14px',
                    fontWeight: 500,
                    lineHeight: '24px',
                    marginLeft: '10px'
                  }}>
                    {patientDisplayId(option)}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </div>
        )}
      </div>
    );
  }
  
  export default CustomDropDownWithSearch;